"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import Button from "../../Common/Buttons/Buttons";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import Loader from "../../Loader/Loader";
import { RxCross2 } from "react-icons/rx";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { useSidebar } from "@/context/SidebarContext";

const Sidebar = ({ onCloseMobile, setIsOpen }) => {
  const pathname = usePathname();
  const router = useRouter();
  const [is404, setIs404] = useState(true);
  const [isNavigating, setIsNavigating] = useState(false);
  const [navigatingTo, setNavigatingTo] = useState("");
  const data = useSelector((state) => state)
  const totalUnreadCount = useSelector(
    (state) => state?.chat?.totalUnreadCount
  );
  const user = useSelector((state) => state?.userData?.userData?.user);

  // Get close function from context or prop (support both prop names)
  let sidebarContext = null;
  try {
    sidebarContext = useSidebar();
  } catch (e) {
    // Context not available
  }
  const closeSidebar = onCloseMobile || (setIsOpen ? () => setIsOpen(false) : null) || sidebarContext?.closeMobileSidebar;

  const handleNavigation = (href) => {
    // Prevent navigation if already on the target page
    if (pathname === href) {
      closeSidebar?.(); // Close sidebar on mobile even if same page
      return;
    }
    setIsNavigating(true);
    setNavigatingTo(href);
    closeSidebar?.(); // Close sidebar on mobile after navigation
    setTimeout(() => {
      router.push(href);
    }, 100);
  };
useEffect(() => {
  let title = document.title;
  console.log("TITLE", title)
  if(title.includes("404:")){
    setIs404(true)
  }else{
    setIs404(false)
  }
}, [])

useEffect(() => {
  // Reset loading state when pathname changes
  setIsNavigating(false);
  setNavigatingTo("");
}, [pathname]);


  return (
    <>
      {isNavigating && <Loader />}
      {user && (user?.type === "clinic" || user?.type === "physician" ) && !is404 &&
      <>
        {/* Sidebar */}
        <div className="h-screen w-[250px] px-4 pt-[22px] bg-white flex flex-col">
          {/* Mobile Close Button */}
          {/* <button
            onClick={() => setIsOpen?.(false)}
            className="absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100 lg:hidden"
          >
            <RxCross2 size={20} />
          </button> */}

          <a onClick={(e) => {
            e.preventDefault();
            handleNavigation("/");
          }}>
            <div className="cursor-pointer ml-1 mb-2.5">
              <Image src={"/Images/AlphaMdLogo.png"} width={154} height={30} alt="logo" />
              <p className="text-[#7C7C8D] text-[8px] font-semibold tracking-[0.15em] mt-1.5">EVIDENCE &bull; EXPERIENCE &bull; OUTCOMES</p>
              <div className="flex items-center gap-2 mt-">
                <span className="text-[#7C7C8D] text-[8px] font-semibold tracking-[0.15em] relative -top-[2px]">INTELLIGENCE BY</span>
                <Image src="/Images/website/mdReviewer.svg" width={80} height={16} alt="MDReviewer" className="h-[44px] w-auto object-contain" />
              </div>
            </div>
          </a>
        <div className="flex-1 min-h-0 overflow-y-auto no-scrollbar pb-4">
          <span className="text-[#8E8E8E] text-[12px] font-medium font-poppins">
            Menu
          </span>
          <div className="pt-4 space-y-2">
            <a
              className={`link ${pathname === "/provider/dashboard" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/dashboard");
              }}
            >
              <div
                className={`group flex cursor-pointer items-center py-3 px-4 gap-4 rounded-lg transition-all ${
                  pathname === "/provider/dashboard"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white text-[#8E8E8E] hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/provider/dashboard"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <g clipPath="url(#clip0_647_4160)">
                    <path d="M7.70828 6.66672H1.45828C0.654144 6.66672 0 6.01257 0 5.20828V1.45828C0 0.654144 0.654144 0 1.45828 0H7.70828C8.51257 0 9.16672 0.654144 9.16672 1.45828V5.20828C9.16672 6.01257 8.51257 6.66672 7.70828 6.66672ZM1.45828 1.25C1.34338 1.25 1.25 1.34338 1.25 1.45828V5.20828C1.25 5.32333 1.34338 5.41672 1.45828 5.41672H7.70828C7.82333 5.41672 7.91672 5.32333 7.91672 5.20828V1.45828C7.91672 1.34338 7.82333 1.25 7.70828 1.25H1.45828Z" />
                    <path d="M7.70828 20H1.45828C0.654144 20 0 19.3458 0 18.5417V9.79169C0 8.9874 0.654144 8.33325 1.45828 8.33325H7.70828C8.51257 8.33325 9.16672 8.9874 9.16672 9.79169V18.5417C9.16672 19.3458 8.51257 20 7.70828 20ZM1.45828 9.58325C1.34338 9.58325 1.25 9.67664 1.25 9.79169V18.5417C1.25 18.6566 1.34338 18.75 1.45828 18.75H7.70828C7.82333 18.75 7.91672 18.6566 7.91672 18.5417V9.79169C7.91672 9.67664 7.82333 9.58325 7.70828 9.58325H1.45828Z" />
                    <path d="M18.5417 20H12.2917C11.4874 20 10.8333 19.3458 10.8333 18.5417V14.7917C10.8333 13.9874 11.4874 13.3333 12.2917 13.3333H18.5417C19.3458 13.3333 20 13.9874 20 14.7917V18.5417C20 19.3458 19.3458 20 18.5417 20ZM12.2917 14.5833C12.1766 14.5833 12.0833 14.6766 12.0833 14.7917V18.5417C12.0833 18.6566 12.1766 18.75 12.2917 18.75H18.5417C18.6566 18.75 18.75 18.6566 18.75 18.5417V14.7917C18.75 14.6766 18.6566 14.5833 18.5417 14.5833H12.2917Z" />
                    <path d="M18.5417 11.6667H12.2917C11.4874 11.6667 10.8333 11.0126 10.8333 10.2083V1.45828C10.8333 0.654144 11.4874 0 12.2917 0H18.5417C19.3458 0 20 0.654144 20 1.45828V10.2083C20 11.0126 19.3458 11.6667 18.5417 11.6667ZM12.2917 1.25C12.1766 1.25 12.0833 1.34338 12.0833 1.45828V10.2083C12.0833 10.3233 12.1766 10.4167 12.2917 10.4167H18.5417C18.6566 10.4167 18.75 10.3233 18.75 10.2083V1.45828C18.75 1.34338 18.6566 1.25 18.5417 1.25H12.2917Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_647_4160">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span
                  className={`text-[16px] font-poppins transition-all ${
                    pathname === "/provider/dashboard"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Dashboard
                </span>
              </div>
            </a>
            <a
              className={`link ${pathname === "/search" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/search");
              }}
            >
              <div
                className={` group flex cursor-pointer items-center mt-1 py-3 px-4 gap-4 transition-all rounded-lg ${
                  pathname === "/search"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/search"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <path
                    d="M18.5687 17.6812L14.5062 13.6187H14.4625C15.7146 12.1423 16.3474 10.2389 16.2284 8.30669C16.1095 6.37445 15.2479 4.56306 13.8241 3.25143C12.4002 1.9398 10.5244 1.22953 8.58888 1.26922C6.65339 1.3089 4.8082 2.09545 3.43932 3.46434C2.07043 4.83323 1.28387 6.67841 1.24419 8.6139C1.20451 10.5494 1.91477 12.4253 3.2264 13.8491C4.53803 15.273 6.34943 16.1345 8.28167 16.2535C10.2139 16.3724 12.1173 15.7397 13.5937 14.4875C13.5937 14.4875 13.5937 14.5187 13.5937 14.5312L17.6562 18.5937C17.7143 18.6523 17.7835 18.6988 17.8596 18.7306C17.9358 18.7623 18.0175 18.7786 18.1 18.7786C18.1825 18.7786 18.2642 18.7623 18.3403 18.7306C18.4165 18.6988 18.4856 18.6523 18.5437 18.5937C18.6078 18.537 18.6595 18.4677 18.6957 18.3902C18.7319 18.3126 18.7518 18.2285 18.7542 18.1429C18.7565 18.0574 18.7413 17.9722 18.7094 17.8928C18.6775 17.8134 18.6296 17.7414 18.5687 17.6812ZM8.74997 15C7.51384 15 6.30547 14.6334 5.27766 13.9467C4.24985 13.2599 3.44877 12.2838 2.97573 11.1418C2.50268 9.99973 2.37891 8.74306 2.62007 7.53068C2.86122 6.3183 3.45648 5.20466 4.33056 4.33058C5.20463 3.4565 6.31828 2.86125 7.53066 2.62009C8.74304 2.37893 9.99971 2.5027 11.1417 2.97575C12.2838 3.4488 13.2599 4.24988 13.9467 5.27768C14.6334 6.30549 15 7.51386 15 8.75C15 9.57076 14.8383 10.3835 14.5242 11.1418C14.2101 11.9001 13.7498 12.589 13.1694 13.1694C12.589 13.7498 11.9 14.2102 11.1417 14.5242C10.3835 14.8383 9.57073 15 8.74997 15Z"
                  />
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/search"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Search
                </span>
              </div>
            </a>
            {/* Discover → Emerging & Pipeline. Sidebar entry that
                routes to the dedicated Discover surface (filters +
                view tabs over the pipeline catalog). */}
            <a
              className={`link ${pathname === "/provider/emerging-pipeline" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/emerging-pipeline");
              }}
            >
              <div
                className={`group flex cursor-pointer items-center mt-1 py-3 px-4 gap-4 transition-all rounded-lg ${
                  pathname === "/provider/emerging-pipeline"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                {/* Outline trending-arrow icon — stroke-based to match
                    the other line icons in the sidebar. Same visual
                    weight (1.6 stroke) as Search / Messages / etc. */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`transition-all ${
                    pathname === "/provider/emerging-pipeline"
                      ? "text-white"
                      : "text-[#8E8E8E] group-hover:text-[#1E5EFF]"
                  }`}
                >
                  <polyline points="3 17 9 11 13 15 21 7" />
                  <polyline points="15 7 21 7 21 13" />
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/provider/emerging-pipeline"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Emerging & Pipeline
                </span>
              </div>
            </a>
            <a
              className={`link ${pathname === "/provider/message" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/message");
              }}
            >
              <div
                className={` group flex cursor-pointer items-center mt-1 py-3 px-4 gap-4 transition-all rounded-lg ${
                  pathname === "/provider/message"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/provider/message"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <g clipPath="url(#clip0_647_4164)">
                    <path d="M19.928 15.6971L18.7664 12.3165C19.3263 11.1719 19.6222 9.8989 19.6242 8.61808C19.6277 6.39101 18.766 4.28526 17.198 2.68877C15.6296 1.09197 13.5397 0.193105 11.3131 0.157831C9.00432 0.121347 6.83416 0.999551 5.20263 2.63104C3.62943 4.20421 2.75685 6.27816 2.72923 8.49441C1.17868 9.66183 0.263482 11.482 0.26649 13.4261C0.267935 14.3358 0.472701 15.2402 0.86071 16.0579L0.060591 18.3864C-0.0769483 18.7867 0.0235207 19.2213 0.322818 19.5206C0.533444 19.7312 0.811139 19.8434 1.09673 19.8434C1.21688 19.8434 1.33845 19.8235 1.457 19.7828L3.78548 18.9827C4.60326 19.3707 5.50759 19.5754 6.41736 19.5769C6.42064 19.5769 6.42377 19.5769 6.42705 19.5769C8.4001 19.5768 10.2341 18.638 11.3973 17.0495C12.6077 17.0176 13.8053 16.7246 14.888 16.1949L18.2686 17.3566C18.4095 17.405 18.5539 17.4286 18.6967 17.4286C19.0361 17.4286 19.3661 17.2953 19.6164 17.0449C19.9721 16.6892 20.0915 16.1728 19.928 15.6971ZM6.42697 18.3864C6.42443 18.3864 6.42174 18.3864 6.4192 18.3864C5.61396 18.3852 4.81431 18.1867 4.10685 17.8124C3.96138 17.7355 3.7906 17.7222 3.63505 17.7756L1.24743 18.596L2.06786 16.2084C2.1213 16.0529 2.10802 15.8821 2.03106 15.7367C1.65677 15.0292 1.45825 14.2295 1.457 13.4243C1.45501 12.129 1.95888 10.9013 2.84001 9.98199C3.12782 11.7365 3.96404 13.3533 5.26021 14.6265C6.54681 15.8902 8.16408 16.6948 9.90909 16.9578C8.98768 17.866 7.74565 18.3864 6.42697 18.3864ZM18.7746 16.2031C18.7407 16.237 18.7006 16.2462 18.6554 16.2306L15.0363 14.987C14.9735 14.9654 14.9081 14.9547 14.8429 14.9547C14.7469 14.9547 14.6512 14.978 14.5646 15.0238C13.5312 15.5705 12.3636 15.8604 11.1877 15.8622C11.1839 15.8622 11.1803 15.8622 11.1765 15.8622C7.2365 15.8622 3.98208 12.6616 3.91966 8.72261C3.88822 6.73882 4.64283 4.8744 6.04443 3.4728C7.44604 2.07119 9.31077 1.31686 11.2943 1.34811C15.2371 1.41065 18.4398 4.67108 18.4338 8.61621C18.4319 9.79207 18.142 10.9598 17.5954 11.993C17.5185 12.1384 17.5052 12.3092 17.5586 12.4648L18.8022 16.0839C18.8177 16.1292 18.8084 16.1693 18.7746 16.2031Z" />
                    <path d="M14.7223 5.44971H7.63015C7.3014 5.44971 7.03491 5.71623 7.03491 6.04494C7.03491 6.37369 7.30144 6.64018 7.63015 6.64018H14.7223C15.0511 6.64018 15.3176 6.37365 15.3176 6.04494C15.3176 5.71623 15.0511 5.44971 14.7223 5.44971Z" />
                    <path d="M14.7223 7.89783H7.63015C7.3014 7.89783 7.03491 8.16435 7.03491 8.49306C7.03491 8.82177 7.30144 9.0883 7.63015 9.0883H14.7223C15.0511 9.0883 15.3176 8.82177 15.3176 8.49306C15.3176 8.16435 15.0511 7.89783 14.7223 7.89783Z" />
                    <path d="M11.9924 10.3458H7.63015C7.3014 10.3458 7.03491 10.6123 7.03491 10.9411C7.03491 11.2698 7.30144 11.5363 7.63015 11.5363H11.9923C12.3211 11.5363 12.5876 11.2698 12.5876 10.9411C12.5876 10.6123 12.3211 10.3458 11.9924 10.3458Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_647_4164">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/provider/message"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Messages {totalUnreadCount ? `(${totalUnreadCount})` : ""}
                </span>
              </div>
            </a>
            <a
              className={`link ${
                pathname === "/provider/doctors-meeting" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/doctors-meeting");
              }}
            >
              <div
                className={` group flex cursor-pointer items-center mt-1 py-3 px-4 gap-4 transition-all rounded-lg ${
                  pathname === "/provider/doctors-meeting"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/provider/doctors-meeting"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1417 8.375C12.7617 8.375 11.6417 9.495 11.6417 10.875C11.6417 12.255 12.7617 13.375 14.1417 13.375C15.5217 13.375 16.6417 12.255 16.6417 10.875C16.6417 9.495 15.5217 8.375 14.1417 8.375ZM14.1417 9.625C14.8317 9.625 15.3917 10.185 15.3917 10.875C15.3917 11.565 14.8317 12.125 14.1417 12.125C13.4517 12.125 12.8917 11.565 12.8917 10.875C12.8917 10.185 13.4517 9.625 14.1417 9.625Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7725 17.9583C13.0392 17.9583 15.25 17.9583 16.5167 17.9475C16.9842 17.9475 17.4275 17.7158 17.6983 17.3275C17.9692 16.9392 18.0325 16.4433 17.8692 15.9992C17.325 14.4733 15.8608 13.375 14.1417 13.375C12.425 13.375 10.9617 14.47 10.4033 15.9958C10.2383 16.4433 10.3025 16.9433 10.5758 17.3342C10.8483 17.7258 11.2958 17.9583 11.7725 17.9583ZM11.7725 16.7083C11.7042 16.7083 11.64 16.675 11.6008 16.6192C11.5617 16.5633 11.5525 16.4917 11.5758 16.4275C11.5767 16.4275 11.5767 16.4267 11.5767 16.4267C11.96 15.3792 12.9633 14.625 14.1417 14.625C15.3183 14.625 16.32 15.3767 16.6942 16.425C16.695 16.4275 16.695 16.43 16.6958 16.4317C16.7183 16.4925 16.71 16.56 16.6725 16.6125C16.6359 16.6658 16.5759 16.6975 16.5108 16.6975C16.5092 16.6975 16.5075 16.6975 16.5058 16.6975C15.2417 16.7083 13.0358 16.7083 11.7725 16.7083Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2917 6.49996V4.41663C16.2917 2.69079 14.8925 1.29163 13.1667 1.29163H3.16669C1.44085 1.29163 0.041687 2.69079 0.041687 4.41663V14.4166C0.041687 16.1425 1.44085 17.5416 3.16669 17.5416H8.16669C8.51169 17.5416 8.79169 17.2616 8.79169 16.9166C8.79169 16.5716 8.51169 16.2916 8.16669 16.2916C8.16669 16.2916 5.34835 16.2916 3.16669 16.2916C2.13085 16.2916 1.29169 15.4525 1.29169 14.4166V4.41663C1.29169 3.38079 2.13085 2.54163 3.16669 2.54163H13.1667C14.2025 2.54163 15.0417 3.38079 15.0417 4.41663V6.49996C15.0417 6.84496 15.3217 7.12496 15.6667 7.12496C16.0117 7.12496 16.2917 6.84496 16.2917 6.49996Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 0.666626V3.16663C4 3.51163 4.28 3.79163 4.625 3.79163C4.97 3.79163 5.25 3.51163 5.25 3.16663V0.666626C5.25 0.321626 4.97 0.041626 4.625 0.041626C4.28 0.041626 4 0.321626 4 0.666626Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0834 0.666626V3.16663C11.0834 3.51163 11.3634 3.79163 11.7084 3.79163C12.0534 3.79163 12.3334 3.51163 12.3334 3.16663V0.666626C12.3334 0.321626 12.0534 0.041626 11.7084 0.041626C11.3634 0.041626 11.0834 0.321626 11.0834 0.666626Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7.95825H6.58333C6.92833 7.95825 7.20833 7.67825 7.20833 7.33325C7.20833 6.98825 6.92833 6.70825 6.58333 6.70825H4C3.655 6.70825 3.375 6.98825 3.375 7.33325C3.375 7.67825 3.655 7.95825 4 7.95825Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 11.2916H8.16667C8.51167 11.2916 8.79167 11.0116 8.79167 10.6666C8.79167 10.3216 8.51167 10.0416 8.16667 10.0416H4C3.655 10.0416 3.375 10.3216 3.375 10.6666C3.375 11.0116 3.655 11.2916 4 11.2916Z"
                  />
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/provider/doctors-meeting"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Meetings{" "}
                </span>
              </div>
            </a>
            <a
              className={`link ${pathname === "/provider/doctors-reps" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/doctors-reps");
              }}
            >
              <div
                className={`flex group transition-all cursor-pointer items-center mt-1 py-3 px-4 gap-4 rounded-lg ${
                  pathname === "/provider/doctors-reps"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/provider/doctors-reps"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <path d="M9.85747 9.63408C11.181 9.63408 12.327 9.15938 13.2635 8.22279C14.1998 7.28636 14.6747 6.14058 14.6747 4.81689C14.6747 3.49365 14.2 2.34771 13.2634 1.41098C12.3268 0.4747 11.1809 0 9.85747 0C8.53378 0 7.388 0.4747 6.45157 1.41113C5.51514 2.34756 5.04028 3.49349 5.04028 4.81689C5.04028 6.14058 5.51514 7.28652 6.45157 8.22295C7.3883 9.15922 8.53423 9.63408 9.85747 9.63408ZM7.28042 2.23983C7.99896 1.5213 8.84185 1.17203 9.85747 1.17203C10.8729 1.17203 11.716 1.5213 12.4347 2.23983C13.1532 2.95852 13.5026 3.80157 13.5026 4.81689C13.5026 5.83251 13.1532 6.6754 12.4347 7.39409C11.716 8.11278 10.8729 8.46205 9.85747 8.46205C8.84216 8.46205 7.99926 8.11263 7.28042 7.39409C6.56173 6.67555 6.21231 5.83251 6.21231 4.81689C6.21231 3.80157 6.56173 2.95852 7.28042 2.23983Z" />
                  <path d="M18.2863 15.379C18.2592 14.9893 18.2046 14.5642 18.1242 14.1153C18.043 13.663 17.9385 13.2354 17.8134 12.8447C17.684 12.4408 17.5084 12.0419 17.2909 11.6597C17.0656 11.2629 16.8007 10.9175 16.5034 10.6332C16.1926 10.3358 15.812 10.0967 15.372 9.9223C14.9334 9.74881 14.4475 9.66092 13.9276 9.66092C13.7234 9.66092 13.526 9.74469 13.1447 9.99295C12.91 10.146 12.6355 10.323 12.3291 10.5188C12.0671 10.6857 11.7122 10.8421 11.2738 10.9837C10.8461 11.1221 10.4118 11.1923 9.98305 11.1923C9.55458 11.1923 9.12032 11.1221 8.69231 10.9837C8.25438 10.8423 7.89931 10.6859 7.63778 10.5189C7.33428 10.325 7.05962 10.148 6.82143 9.9928C6.44042 9.74454 6.24297 9.66077 6.03881 9.66077C5.51879 9.66077 5.03295 9.74881 4.59457 9.92245C4.15481 10.0966 3.7741 10.3357 3.46298 10.6334C3.16574 10.9178 2.90085 11.2631 2.67563 11.6597C2.45849 12.0419 2.28271 12.4406 2.15332 12.8448C2.02835 13.2356 1.92383 13.663 1.84265 14.1153C1.76208 14.5636 1.70761 14.9888 1.6806 15.3794C1.65405 15.7614 1.64062 16.1589 1.64062 16.5605C1.64062 17.6045 1.9725 18.4497 2.62695 19.073C3.27331 19.6881 4.12841 19.9999 5.1686 19.9999H14.7987C15.8386 19.9999 16.6937 19.6881 17.3402 19.073C17.9948 18.4501 18.3267 17.6046 18.3267 16.5603C18.3265 16.1573 18.313 15.7598 18.2863 15.379ZM16.5321 18.2238C16.105 18.6303 15.538 18.8279 14.7986 18.8279H5.1686C4.42901 18.8279 3.862 18.6303 3.43506 18.224C3.0162 17.8253 2.81265 17.281 2.81265 16.5605C2.81265 16.1857 2.82501 15.8157 2.84973 15.4605C2.87384 15.112 2.92312 14.7291 2.99621 14.3223C3.06839 13.9206 3.16024 13.5435 3.2695 13.2022C3.37433 12.8749 3.5173 12.5508 3.69461 12.2386C3.86383 11.941 4.05853 11.6858 4.27337 11.4801C4.47433 11.2877 4.72762 11.1302 5.02609 11.0121C5.30212 10.9028 5.61233 10.843 5.94909 10.834C5.99013 10.8558 6.06322 10.8975 6.18163 10.9747C6.42257 11.1317 6.70028 11.3108 7.00728 11.5069C7.35335 11.7276 7.79921 11.9268 8.3319 12.0988C8.87648 12.2749 9.4319 12.3643 9.9832 12.3643C10.5345 12.3643 11.0901 12.2749 11.6343 12.099C12.1675 11.9267 12.6132 11.7276 12.9597 11.5066C13.2739 11.3058 13.5438 11.1319 13.7848 10.9747C13.9032 10.8976 13.9763 10.8558 14.0173 10.834C14.3542 10.843 14.6644 10.9028 14.9406 11.0121C15.2389 11.1302 15.4922 11.2878 15.6932 11.4801C15.908 11.6856 16.1027 11.9409 16.2719 12.2387C16.4494 12.5508 16.5925 12.875 16.6972 13.202C16.8066 13.5438 16.8986 13.9207 16.9706 14.3222C17.0436 14.7297 17.093 15.1127 17.1171 15.4606V15.4609C17.142 15.8148 17.1545 16.1846 17.1547 16.5605C17.1545 17.2811 16.951 17.8253 16.5321 18.2238Z" />
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/provider/doctors-reps"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Reps{" "}
                </span>
              </div>{" "}
            </a>
            <a
              className={`link ${pathname === "/provider/favorites" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/provider/favorites");
              }}
            >
              <div
                className={`flex group transition-all cursor-pointer items-center mt-1 py-3 px-4 gap-4 rounded-lg ${
                  pathname === "/provider/favorites"
                    ? "bg-[#354EF0] text-white"
                    : "bg-white hover:bg-[#354EF00A]"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={`transition-all ${
                    pathname === "/provider/favorites"
                      ? "fill-white"
                      : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                  }`}
                >
                  <g clipPath="url(#clip0_647_4176)">
                    <path d="M18.2156 2.91829C17.063 1.76569 15.5306 1.13098 13.9006 1.13098C12.459 1.13098 11.0937 1.62753 9.99997 2.53959C8.90634 1.62753 7.54099 1.13098 6.09944 1.13098C4.46945 1.13098 2.93702 1.76573 1.78442 2.91829C-0.594808 5.29756 -0.594808 9.16898 1.78442 11.5483L8.47575 18.2396C8.88168 18.6455 9.42297 18.869 10 18.869C10.577 18.869 11.1183 18.6455 11.5243 18.2396L18.2156 11.5483C20.5948 9.16898 20.5948 5.29752 18.2156 2.91829ZM17.3867 10.7195L10.6954 17.4107C10.5109 17.5952 10.264 17.6968 10 17.6968C9.73607 17.6968 9.48912 17.5952 9.30462 17.4107L2.61333 10.7195C0.691145 8.79715 0.691144 5.66938 2.61329 3.74716C3.5445 2.81595 4.78258 2.30315 6.09944 2.30315C7.4163 2.30315 8.65439 2.81595 9.58556 3.74712C9.81437 3.97601 10.1855 3.97601 10.4144 3.74712C11.3456 2.81591 12.5837 2.30311 13.9006 2.30311C15.2175 2.30311 16.4556 2.81591 17.3867 3.74708C19.3089 5.66938 19.3089 8.79715 17.3867 10.7195Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_647_4176">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span
                  className={`text-[16px] font-medium font-poppins ${
                    pathname === "/provider/favorites"
                      ? "text-white font-medium"
                      : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                  }`}
                >
                  Favorites
                </span>
              </div>
            </a>
            <div
              className=" flex group transition-all cursor-pointer items-center py-3 px-4 gap-4 rounded-lg"

              // className={`flex cursor-pointer items-center py-3 px-4 gap-4 rounded-lg ${
              //   activeTab === "Lists" ? "bg-[#354EF0]" : ""
              // }`}
              // onClick={() => setActiveTab("Lists")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                className={`transition-all ${
                  pathname === "/Lists"
                    ? "fill-white"
                    : "fill-[#8E8E8E] group-hover:fill-[#1E5EFF]"
                }`}
              >
                <path d="M19.0024 17.2623H5.62845C5.07724 17.2623 4.63049 16.8155 4.63049 16.2643C4.63049 15.7131 5.07724 15.2664 5.62845 15.2664H19.002C19.5532 15.2664 20 15.7131 20 16.2643C20 16.8155 19.5536 17.2623 19.0024 17.2623Z" />
                <path d="M19.0024 10.9981H5.62845C5.07724 10.9981 4.63049 10.5514 4.63049 10.0002C4.63049 9.44895 5.07724 9.0022 5.62845 9.0022H19.002C19.5532 9.0022 20 9.44895 20 10.0002C20.0003 10.5514 19.5536 10.9981 19.0024 10.9981Z" />
                <path d="M19.0024 4.73395H5.62845C5.07724 4.73395 4.63049 4.28719 4.63049 3.73599C4.63049 3.18479 5.07724 2.73804 5.62845 2.73804H19.002C19.5532 2.73804 20 3.18479 20 3.73599C20 4.28719 19.5536 4.73395 19.0024 4.73395Z" />
                <path d="M1.34025 5.15341C2.08045 5.15341 2.6805 4.55335 2.6805 3.81315C2.6805 3.07295 2.08045 2.4729 1.34025 2.4729C0.600051 2.4729 0 3.07295 0 3.81315C0 4.55335 0.600051 5.15341 1.34025 5.15341Z" />
                <path d="M1.34025 11.3404C2.08045 11.3404 2.6805 10.7404 2.6805 10.0002C2.6805 9.25996 2.08045 8.65991 1.34025 8.65991C0.600051 8.65991 0 9.25996 0 10.0002C0 10.7404 0.600051 11.3404 1.34025 11.3404Z" />
                <path d="M1.34025 17.5274C2.08045 17.5274 2.6805 16.9274 2.6805 16.1872C2.6805 15.447 2.08045 14.8469 1.34025 14.8469C0.600051 14.8469 0 15.447 0 16.1872C0 16.9274 0.600051 17.5274 1.34025 17.5274Z" />
              </svg>
              <span
                className={`text-[16px] font-poppins ${
                  pathname === "Lists"
                    ? "text-white font-medium"
                    : "text-[#8E8E8E] font-normal group-hover:text-[#1E5EFF]"
                }`}
              >
                Lists{" "}
              </span>
            </div>{" "}
            <div
              className=" flex cursor-pointer items-center  mt-1 py-3 px-4 gap-4 rounded-lg"

              // className={`flex cursor-pointer items-center py-3 px-4 gap-4 rounded-lg ${
              //   activeTab === "Communities" ? "bg-[#354EF0]" : ""
              // }`}
              // onClick={() => setActiveTab("Communities")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <g clipPath="url(#clip0_647_4314)">
                  <path
                    d="M1.51562 10.2344C1.51953 10.2383 1.52344 10.2422 1.52734 10.2461L3.67578 12.2773C3.23047 12.9843 3.3125 13.9336 3.92969 14.5508C4.28125 14.9023 4.73828 15.0781 5.19531 15.0859C5.21094 15.5547 5.39844 16.0195 5.75781 16.3789C6.11328 16.7343 6.58594 16.9336 7.08984 16.9414C7.09766 17.4258 7.28516 17.9023 7.65234 18.2734C8.36719 19.0195 9.65625 19.0195 10.375 18.2734L11.543 17.1054L11.8047 17.3672C12.5625 18.125 13.8008 18.125 14.5586 17.3672L14.5742 17.3515C14.9414 16.9844 15.1289 16.5078 15.1445 16.0234C15.6484 16.0273 16.1484 15.8359 16.5312 15.4531L16.5469 15.4375C16.9102 15.0742 17.1133 14.5937 17.1172 14.0781C17.6094 14.0742 18.0977 13.8828 18.4727 13.5078L18.4883 13.4922C19.2461 12.7343 19.2461 11.4961 18.4883 10.7383L18.2891 10.539L18.3906 10.4375C23.2617 5.14451 16.0195 -2.08987 10.7305 2.77732L9.73047 3.77732L8.83594 2.90622C6.8125 0.894506 3.53125 0.894506 1.51562 2.91013C-0.503906 4.92966 -0.503906 8.21482 1.51562 10.2344ZM17.6406 12.6797C17.3359 12.9844 16.8438 12.9844 16.543 12.6797L15.4688 11.6054C15.168 11.3164 15.168 10.7969 15.4688 10.5078L15.4844 10.4922C15.7734 10.1914 16.293 10.1914 16.582 10.4922L17.6562 11.5664C17.9609 11.8711 17.9609 12.3633 17.6562 12.664L17.6406 12.6797ZM14.5977 14.625L12.8398 12.8672C12.5391 12.5781 12.5391 12.0586 12.8398 11.7695L12.8555 11.7539C13.1602 11.4492 13.6523 11.4492 13.9531 11.7539L14.6328 12.4336L15.707 13.5078C16.0078 13.7968 16.0078 14.3164 15.707 14.6054L15.6914 14.6211C15.3945 14.9258 14.9023 14.9258 14.5977 14.625ZM12.625 16.539L11.9297 15.8437C11.6289 15.5547 11.6289 15.0351 11.9297 14.7461L11.9453 14.7304C12.25 14.4258 12.7422 14.4258 13.043 14.7304L13.7383 15.4258C14.043 15.7304 14.043 16.2226 13.7383 16.5234L13.7227 16.539C13.4219 16.8398 12.9297 16.8398 12.625 16.539ZM4.75781 12.789L8.77734 8.76951C8.79688 8.74997 8.83203 8.74997 8.85156 8.76951L9.5 9.41794C10.2812 10.2344 11.6914 10.2344 12.4727 9.41794C13.2969 8.62888 13.2852 7.19919 12.4492 6.42185L10.5703 4.59763L11.5586 3.60935C13.2148 1.9531 15.9062 1.9531 17.5625 3.60935C19.2188 5.2656 19.2188 7.95701 17.5625 9.61326L17.4609 9.71482L17.4102 9.66404C16.6836 8.91013 15.3789 8.91013 14.6563 9.66404L14.6406 9.67966C14.4062 9.91404 14.2422 10.1953 14.1523 10.5C13.4453 10.2109 12.6055 10.3515 12.0352 10.9219L12.0195 10.9375C11.3477 11.582 11.2617 12.707 11.8125 13.4492C11.5625 13.5429 11.3242 13.6914 11.1211 13.8945L11.1055 13.9101C10.5 14.4961 10.3594 15.4844 10.7695 16.2187L9.54688 17.4414C9.26562 17.7344 8.76172 17.7344 8.48047 17.4414C8.18359 17.1445 8.1875 16.664 8.48438 16.3711L9.57031 15.2851C9.80078 15.0547 9.80078 14.6875 9.57031 14.457C9.33984 14.2265 8.97266 14.2265 8.74219 14.457L7.65234 15.5469C7.37109 15.8398 6.86719 15.8398 6.58594 15.5469C6.29297 15.2539 6.29297 14.7773 6.58594 14.4804L7.68359 13.3828C7.91406 13.1523 7.91406 12.7851 7.68359 12.5547C7.45312 12.3242 7.08594 12.3242 6.85547 12.5547C6.85547 12.5547 5.69922 13.7109 5.69531 13.7148C5.4375 13.9726 5.01953 13.9726 4.76172 13.7148C4.5 13.4648 4.5 13.0468 4.75781 12.789ZM2.34375 3.74216C3.90625 2.17966 6.45312 2.17966 8.01562 3.74997L11.6328 7.2656C11.8125 7.44138 11.9141 7.67576 11.918 7.92576C11.9258 8.75779 10.918 9.17576 10.3281 8.58982L9.67969 7.94138C9.22266 7.46482 8.40625 7.46482 7.94922 7.94138L4.47266 11.4179L2.33984 9.39841C0.78125 7.83982 0.78125 5.30076 2.34375 3.74216Z"
                    style={{
                      fill: pathname === "Communities" ? "#FFFFFF" : "#8E8E8E",
                    }}
                  />
                </g>
                <defs>
                  <clipPath id="clip0_647_4314">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span
                className={`text-[16px] font-medium font-poppins ${
                  pathname === "Communities"
                    ? "text-white font-medium"
                    : "text-[#8E8E8E] font-normal"
                }`}
              >
                Communities{" "}
              </span>
            </div>{" "}
            <div
              className=" flex cursor-pointer items-center mt-1 py-3 px-4 gap-4 rounded-lg"
              // className={`flex cursor-pointer items-center   py-3 px-4 gap-4 rounded-lg ${
              //   activeTab === "MDReviewer" ? "bg-[#354EF0]" : ""
              // }`}
              // onClick={() => setActiveTab("MDReviewer")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <g clipPath="url(#clip0_691_6097)">
                  <path
                    d="M19.0562 10.6582C18.8076 10.6582 18.5691 10.757 18.3933 10.9328C18.2175 11.1086 18.1187 11.347 18.1187 11.5957V15.3695C18.1179 16.0984 17.828 16.7972 17.3126 17.3126C16.7972 17.828 16.0984 18.1179 15.3695 18.1187H4.63044C3.90156 18.1179 3.20277 17.828 2.68737 17.3126C2.17197 16.7972 1.88205 16.0984 1.88123 15.3695V4.63044C1.88205 3.90156 2.17197 3.20277 2.68737 2.68737C3.20277 2.17197 3.90156 1.88205 4.63044 1.88123H8.40427C8.65291 1.88123 8.89137 1.78245 9.06719 1.60664C9.243 1.43082 9.34177 1.19237 9.34177 0.943726C9.34177 0.695085 9.243 0.456628 9.06719 0.280813C8.89137 0.104998 8.65291 0.00622559 8.40427 0.00622559H4.63044C3.40447 0.0076729 2.22912 0.495331 1.36223 1.36223C0.495331 2.22912 0.0076729 3.40447 0.00622559 4.63044V15.3695C0.0076729 16.5955 0.495331 17.7708 1.36223 18.6377C2.22912 19.5046 3.40447 19.9923 4.63044 19.9937H15.3695C16.5955 19.9923 17.7708 19.5046 18.6377 18.6377C19.5046 17.7708 19.9923 16.5955 19.9937 15.3695V11.5957C19.9937 11.347 19.895 11.1086 19.7191 10.9328C19.5433 10.757 19.3049 10.6582 19.0562 10.6582Z"
                    style={{
                      fill: pathname === "MDReviewer" ? "#FFFFFF" : "#8E8E8E",
                    }}
                  />
                  <path
                    d="M19.0363 7.92094e-08H13.2082C12.9627 -4.69992e-05 12.727 0.0962009 12.5517 0.268065C12.3764 0.439929 12.2755 0.673696 12.2707 0.919141C12.2609 1.44531 12.7035 1.875 13.2293 1.875H16.7969L9.33047 9.34375C9.15467 9.51956 9.05591 9.75801 9.05591 10.0066C9.05591 10.2553 9.15467 10.4937 9.33047 10.6695C9.50629 10.8453 9.74473 10.9441 9.99336 10.9441C10.242 10.9441 10.4804 10.8453 10.6563 10.6695L18.125 3.20313V6.78359C18.125 7.03224 18.2238 7.27069 18.3996 7.44651C18.5754 7.62232 18.8139 7.72109 19.0625 7.72109C19.3111 7.72109 19.5496 7.62232 19.7254 7.44651C19.9012 7.27069 20 7.03224 20 6.78359V0.963281C20 0.836749 19.9751 0.711456 19.9266 0.594559C19.8782 0.477663 19.8072 0.371455 19.7177 0.282001C19.6282 0.192546 19.522 0.1216 19.4051 0.0732134C19.2882 0.0248269 19.1629 -5.12317e-05 19.0363 7.92094e-08Z"
                    style={{
                      fill: pathname === "MDReviewer" ? "#FFFFFF" : "#8E8E8E",
                    }}
                  />
                </g>
                <defs>
                  <clipPath id="clip0_691_6097">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span
                className={`text-[16px] font-poppins ${
                  pathname === "MDReviewer"
                    ? "text-white font-medium"
                    : "text-[#8E8E8E] font-normal"
                }`}
              >
                MDReviewer{" "}
              </span>
            </div>
          </div>
          <div className="w-[184px] h-[137px] p-3 mt-8 bg-neutral-50 flex-col justify-center items-start gap-3 inline-flex">
            <div className="self-stretch flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-black text-sm font-semibold font-poppins">
                Need help?
              </div>
              <div className="text-neutral-400 text-xs font-normal font-poppins">
                We’re here to help you in case you’re stuck
              </div>
            </div>
            <a onClick={(e) => {
              e.preventDefault();
              handleNavigation("/contact-us");
            }}>
              <Button
                textColor={"#354EF0"}
                border={"1px solid #354EF0"}
                fontSize={"14px"}
                borderRadius={"10px"}
                fontWeight={"500"}
                padding={"8px 40px"}
              >
                Contact Us
              </Button>
            </a>
          </div>
        </div>
      </div>
      </>}
    </>
  );
};

export default Sidebar;
